import React, { useContext } from "react";
import { Form, Input, Button, Checkbox, Icon, notification } from "antd";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";

import Header from "../../../User/Header";

import { GlobalContext } from "../../../app/providers/GlobalState";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
        iconLoading: false
    });
};

const Login = ({ form, match }) => {
    const context = useContext(GlobalContext);

    const [isLoading, setIsLoading] = React.useState(false);
    const [redirect, setRedirect] = React.useState(false);
    const [redirectLink, setRedirectLink] = React.useState("");

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (!err) {
                handleLogin(values);
            }
        });
    };

    const handleLogin = registo => {
        setIsLoading(true);

        var item = new FormData();
        item.append("email", registo.email);
        item.append("password", registo.password);
        item.append("rememberMe", registo.remember);
        item.append("entidadeUrl", match.params.entidade);

        axios({
            method: "post",
            url: "/api/autenticacaonew/login",
            data: item
        })
            .then(response => {
                const { token, role, informacoes, senhaValida, link } = response.data;

                if (token) {
                    localStorage.setItem("accessToken", token);
                    localStorage.removeItem("redirecionado");

                    axios.defaults.headers.common.Authorization = `Bearer ${token}`;

                    context.atualizarState({
                        atualizarEntidadeFooter: true,
                        is_authenticated: true,
                        is_authenticated_nav: true,
                        role: role ? role : "",
                        informacoes: informacoes,
                        utilizadorCarregado: null
                    });

                    localStorage.removeItem("entidadeId");
                    localStorage.removeItem("nome_curso");
                    localStorage.removeItem("escola_selecionada");
                    localStorage.removeItem("perfil_selecionado");
                    localStorage.removeItem("redirecionar");
                    localStorage.setItem("mostrarModal", true);

                    if (senhaValida) {
                        setRedirectLink(link);
                        setRedirect(true);
                    }

                    setRedirectLink(`/${match.params.entidade}/alteracao-senha`);
                    setRedirect(true);
                } else {
                    localStorage.removeItem("accessToken");
                    delete axios.defaults.headers.common.Authorization;
                }
            })
            .catch(error => {
                const [errorCode, ...params] = error.response.data.split(";");
                const entidadeUrl = localStorage.getItem("entidade_url");

                const errorHandlers = {
                    INATIVA: () => {
                        openNotificationWithIcon(
                            "warning",
                            "Aviso",
                            <>
                                Conta inativa ou excluída. Por favor entre em contato com o{" "}
                                <Link
                                    to={`/${entidadeUrl}/suporte-contacto`}
                                    style={{
                                        border: "none",
                                        background: "none",
                                        color: "#16817a",
                                        cursor: "pointer",
                                        padding: 0
                                    }}
                                >
                                    <strong>suporte</strong>
                                </Link>
                            </>
                        );
                    },

                    SEM_TERMOS_POLITICA: () => {
                        openNotificationWithIcon(
                            "warning",
                            "Aviso",
                            <>
                                Não concluiu o seu registo. <br />
                                Para finalizar tem de aceitar a <strong>Política de Privacidade</strong> e os <strong>Termos de Uso</strong>
                            </>
                        );

                        localStorage.setItem("codigo_utilizador", params[0]);

                        setRedirectLink(`/${match.params.entidade}/utilizador-registar-passo-2`);
                        setRedirect(true);
                    },

                    default: () => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                    }
                };

                (errorHandlers[errorCode] || errorHandlers.default)();
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const { getFieldDecorator } = form;

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Header titulo="Login" style={{ height: 80 }} marginTop0 />
            <div className="content">
                <Form onSubmit={handleSubmit} className="login template-form">
                    <Form.Item label="E-mail">
                        {getFieldDecorator("email", {
                            rules: [
                                {
                                    required: true,
                                    message: "Introduza o e-mail"
                                },
                                {
                                    type: "email",
                                    message: "Introduza um e-mail válido"
                                }
                            ]
                        })(
                            <Input
                                onKeyDown={e => {
                                    if (e.key === " ") e.preventDefault();
                                }}
                                onChange={e => {
                                    e.target.value = e.target.value.replace(/\s/g, "");
                                }}
                            />
                        )}
                    </Form.Item>
                    <Form.Item label="Senha">
                        {getFieldDecorator("password", {
                            rules: [
                                {
                                    required: true,
                                    message: "Introduza a senha"
                                }
                            ]
                        })(
                            <Input.Password
                                type="password"
                                onKeyDown={e => {
                                    if (e.key === " ") e.preventDefault();
                                }}
                                onChange={e => {
                                    e.target.value = e.target.value.replace(/\s/g, "");
                                }}
                            />
                        )}
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0, marginTop: "auto" }}>
                        <Button type="primary" htmlType="submit" disabled={isLoading} className="login-form-button form-button">
                            {isLoading ? <Icon type="loading" /> : null}
                            Entrar
                        </Button>
                        {getFieldDecorator("remember", {
                            valuePropName: "checked",
                            initialValue: false
                        })(
                            <Checkbox>
                                <span className="ant-lembrar-dados">Lembrar os meus dados</span>
                            </Checkbox>
                        )}
                        <div className="bloco-login-links">
                            <Link to={`/${match.params.entidade}/recuperar-senha-escola`} className="form-link">
                                Esqueci a senha <i className="fas fa-chevron-right"></i>
                            </Link>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </>
    );
};

const LoginForm = Form.create({ name: "form_login_publico" })(Login);

export default LoginForm;
